<template>
  <div class="error-enter" :class="{ show: activeError }">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "InfoAlert.vue",
  props: ["text", "activeError"],
};
</script>

<style scoped lang="scss">
.error-enter {
  &.red {
    background-color: #d54150;
  }
  &.green {
    background-color: #5ea95b;
  }
  &.yellow {
    background-color: #c4a644;
  }
  padding: 20px 40px;
  font-size: 22px;
  color: #fff;
  border-radius: 0 0 20px 20px;
  position: fixed;
  top: 0px;
  left: 50%;
  transform: translate(-50%, -100%);
  transition:
    transform 0.5s,
    opacity 0.3s;
  opacity: 0;
  &.show {
    transform: translate(-50%, 0);
    opacity: 1;
    z-index: 1111;
  }
}
</style>
